import * as React from 'react';
import { SearchNormal1 } from '@/components/icons';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

type SearchFieldProps = Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'id' | 'onChange' | 'type'
> & {
    id?: string;
    inputId?: string;
    onValueChange: (value: string) => void;
    inputClassName?: string;
    iconClassName?: string;
};

const SearchField = React.forwardRef<HTMLInputElement, SearchFieldProps>(
    (
        { id, inputId, className, inputClassName, iconClassName, value, onValueChange, ...props },
        ref,
    ) => (
        <div id={id} className={cn('relative w-full', className)}>
            <SearchNormal1
                aria-hidden="true"
                className={cn(
                    'pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground',
                    iconClassName,
                )}
            />
            <Input
                ref={ref}
                id={inputId}
                type="text"
                role="searchbox"
                enterKeyHint="search"
                value={value}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    onValueChange(event.target.value)
                }
                className={cn('pl-10', inputClassName)}
                {...props}
            />
        </div>
    ),
);

SearchField.displayName = 'SearchField';

export default SearchField;
